import axiosInstance from '../utils/AxiosConfig';

// Catálogo + estado de plugins para la empresa autenticada. Pega a /plugins/status
// (no exige VIEW_SETTINGS) en vez de /plugins -- lo necesita cualquier empleado
// autenticado, no solo quien administra Settings, para que PluginRoute pueda
// ocultar rutas de plugins que la empresa apagó (ver PluginsContext).
export const getPlugins = async () => {
  const response = await axiosInstance.get('/plugins/status', { skipGlobalErrorRedirect: true });
  return response.data?.data || [];
};

export const updatePlugin = async (key, enabled) => {
  const response = await axiosInstance.put(`/plugins/${key}`, { enabled });
  return response.data?.data;
};
